import React, { Component } from "react";
import { push } from "../Services/Analytics"

import "./ManotRows.scss"

class ManotRows extends Component {
  constructor() {
    super()
    this.state = {
    }
  }
  render() {
    return (
      <div className="item">
        <div className="item-padding">
          <div className="remove" onClick={() => { push("falafel - Removed From List", "Button"); this.props.removeSelected(this.props.item.ID); this.props.getMeal(this.props.item, Math.round(this.props.current - 1)) }}></div>
          <div className="name">
            {this.props.item.Title}
          </div>
        </div>
      </div>
    );
  }
}

export default ManotRows;



// WEBPACK FOOTER //
// ./src/Components/ManotSelected/ManotRows.js